export default {
  fr: {
    challenge: 'Le défi',
    solution: 'La solution',
    'recent-result': 'Un résultat récent',
    money: 'À quoi serviront les dons',
    goal: 'Un objectif de réalisation',
    'project.amount_max': 'demandés pour financer ce projet',
    'made-by': 'Fait avec ❤️ par',
    donation: 'Je fais un don',
    project: 'Le projet',
    'brand-like': (brand: string) => `Pourquoi ${brand} aime ce projet ?`,
    'source-organization':
      'Cette association a été méticuleusement sélectionnée et vérifiée par notre partenaire',
  },
  en: {
    challenge: 'Challenge',
    solution: 'Solution',
    'recent-result': 'Recent result',
    'project.amount_max': 'asked for this projet',
    money: 'Use of the money',
    goal: 'Goal',
    'made-by': 'Made with ❤️ by',
    donation: 'Donate',
    'brand-like': (brand: string) => `Why does ${brand} like this project?`,
    project: 'The project',
    'source-organization':
      'This association has been meticulously selected and checked by our partner',
  },
  'pt-br': {
    challenge: 'Desafio',
    solution: 'Solução',
    'recent-result': 'Resultado recente',
    'project.amount_max': 'solicitado para este projeto',
    money: 'Para que servirão as doações',
    goal: 'Objetivo',
    'made-by': 'Feito com ❤️ por',
    donation: 'Eu faço uma doação',
    'brand-like': (brand: string) => `Por que ${brand} gosta deste projeto?`,
    project: 'O projeto',
    'source-organization':
      'Essa associação foi meticulosamente selecionada e verificada por nosso parceiro',
  },
  es: {
    challenge: 'Reto',
    solution: 'Solución',
    'recent-result': 'Resultado reciente',
    'project.amount_max': 'pedido para este proyecto',
    money: 'Para qué servirán las donaciones',
    goal: 'Objetivo',
    'made-by': 'Hecho con ❤️ por',
    donation: 'Hago una donación',
    'brand-like': (brand: string) =>
      `¿Por qué le gusta este proyecto a ${brand}?`,
    project: 'El proyecto',
    'source-organization':
      'Esta asociación ha sido meticulosamente seleccionada y comprobada por nuestro socio',
  },
  de: {
    challenge: 'Herausforderung',
    solution: 'Lösung',
    'recent-result': 'Aktuelles Ergebnis',
    'project.amount_max': 'für dieses Projekt angefragt',
    money: 'Wofür werden die Spenden verwendet',
    goal: 'Ziel',
    'made-by': 'Erstellt mit ❤️ von',
    donation: 'Ich mache eine Spende',
    'brand-like': (brand: string) => `Warum mag ${brand} dieses Projekt?`,
    project: 'Das Projekt',
    'source-organization':
      'Diese Assoziation wurde von unserem Partner akribisch ausgewählt und überprüft.',
  },
} as const
